// import local dependencies
import "jquery";
import "../scss/main.scss";

import Router from "./util/Router";
import common from "./routes/common";

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

jQuery(document).on("elementor/popup/show", (event, id, instance) => {
  if (id === 4111) {
    // the ID of the popup
    $(".features").length;
    {
      const swiper = new Swiper(".features", {
        direction: "horizontal",
        draggable: true,
        slidesPerView: 1,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1400: {
            slidesPerView: 4,
          },
          768: {
            slidesPerView: 2,
          },
        },
      });
    }
  }
});

jQuery(document).ready(function ($) {
  $(document).on("click", ".pagination a", function (e) {
    e.preventDefault();

    var link = $(this).attr("href");
    var archiveContent = $("#archive-content");

    $.ajax({
      url: link,
      type: "GET",
      beforeSend: function () {
        archiveContent.css("opacity", "0.5"); // Add a loading effect
      },
      success: function (response) {
        var newContent = $(response).find("#archive-content").html();
        archiveContent.html(newContent).css("opacity", "1"); // Replace content
        $("html, body").animate(
          { scrollTop: archiveContent.offset().top },
          500
        ); // Scroll to top of content
      },
      error: function () {
        console.log("Error loading content.");
      },
    });
    return false;
  });

  $("#wpsl-search-input").val("Jakarta");
  //$('#wpsl-search-input').val('Jakarta, ജക്കാർത്ത');

  $('.site-sealy-of-indonesia .wpsl-radio-group input[type="radio"]').on(
    "change",
    function () {
      $('.site-sealy-of-indonesia .wpsl-radio-group input[type="radio"]')
        .parent("label")
        .removeClass("is-active"); // Remove "is-active" class from all labels
      $(this).parent("label").addClass("is-active"); // Add "is-active" class to parent label

      // Get the value of the selected radio button
      const selectedValue = $(this).val();
      console.log(selectedValue);

      // Find the option in the #wpsl-category dropdown with the same value and select it
      $("#wpsl-category-list")
        .find('option[value="' + selectedValue + '"]')
        .prop("selected", "selected");
      $(".wpsl-selected-item").attr("data-value", selectedValue);

      $("#wpsl-search-btn").trigger("click");
    }
  );
});
